var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{key:_vm.$route.fullPath,staticClass:"toeic_main"})
}
var staticRenderFns = []

export { render, staticRenderFns }